<template>
    <div>
        <shop-head currentPageName="businees_publish"></shop-head>
        <div class="content mt-10 mb-10 ">
            <div class="container flex-row ">
                <div class="menuList  mr-10">
                    <el-row class="tac">
                        <!-- :default-active="$route.path" -->
                        <el-col :span="12" class="e_col ">
                            <el-menu 
                                router
                                default-active="/my/my_businees_publish"
                                class="el-menu-vertical-demo" 
                                @open="handleOpen"
                                @close="handleClose" popper-class="bortest">

                                <el-submenu index="1" >
                                    <template slot="title">
                                        <i class="el-icon-location"></i>
                                        <span >{{ $t('商机管理')}}</span>
                                    </template>
                                    
                                    <el-menu-item-group>
                                        <el-menu-item index="/my/comingsoon">{{$t('我的商机')}}</el-menu-item>
                                    </el-menu-item-group>      
                                </el-submenu>

                                 <el-submenu index="2" class="" >
                                    <template slot="title" >
                                        <i class="el-icon-location"></i>
                                        <span class="" 
                                         style="">
                                            {{$t('产品管理')}} 
                                        </span>
                                    </template>
                                    <el-menu-item-group>
                                        <el-menu-item index="/my/my_product">{{$t('我的产品')}}</el-menu-item>
                                    </el-menu-item-group>      
                                </el-submenu>
                                <el-submenu index="3">
                                    <template slot="title">
                                        <i class="el-icon-location"></i>
                                        <span>{{$t('参展管理')}}</span>
                                    </template>
                                    <el-menu-item-group>
                                            <el-menu-item index="/my/my_businees_publish">{{$t('我的展位')}}</el-menu-item>
                                    </el-menu-item-group>      
                                </el-submenu>
                                <el-submenu index="4">
                                    <template slot="title">
                                        <i class="el-icon-location"></i>
                                        <span>{{$t('我的收藏')}}</span>
                                    </template>
                                    <el-menu-item-group>
                                         <el-menu-item index="/my/comingsoon?id=4-1">{{$t('关注工厂')}}</el-menu-item>
                                       <el-menu-item index="/my/comingsoon?id=4-2">{{$t('关注产品')}}</el-menu-item>
                                    </el-menu-item-group>      
                                </el-submenu>
                                <el-menu-item index="/my/comingsoon?id=5">           
                                    <i class="el-icon-location"></i>
                                    <span>{{$t('个人中心')}}</span>
                                </el-menu-item>
                                <el-menu-item index="/my/comingsoon?id=6">  
                                    <i class="el-icon-location"></i>
                                    <span slot="title">{{$t('企业信息')}}</span>
                                </el-menu-item>
                            </el-menu>
                        </el-col>

                    </el-row>
                </div>

                <div class="main ">
                    <router-view></router-view>
                </div>

            </div>
        </div>
        <common-footer></common-footer>
    </div>
</template>
<script>
import shopHead from '../../components/shop/head'
import commonFooter from '../../components/common/footer'
export default {
    components: {
        shopHead,
        commonFooter,
    },
    data() {
        return {
        }
    },
    activated() {
    },
    methods: {
   


        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        }
    }
}
</script>
<style  lang= scss scoped>
.content {
    /* width: 1200px; */
    .container {
        /* width: 80% !important; */
        background-color: white;
        height: auto;
        .menuList {
            background-color: white;
            width: 19%;
            min-height: 500px;
            .el-col-12 {
               width: 100%;
            }
        }
        .main{
            width: 100%;
            background-color: white;
            min-height: 500px;
        }
        .e_col{
            span{


            }
        }
        .el-menu-vertical-demo:not(.el-menu--collapse) {
            width: 200px;
            min-height: 400px;
        }
        // .submenu-with-wrap .el-menu-item span {
        //     white-space: normal; /* 允许文本换行 */
        //     word-wrap: break-word; /* 长单词也能换行 */
        // }
    }
    
}
</style>
